import script from "./UFiltersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UFiltersView.vue?vue&type=script&setup=true&lang=ts"

import "./UFiltersView.vue?vue&type=style&index=0&id=4fb179ba&lang=css"

const __exports__ = script;

export default __exports__